import Axios from 'axios'

// usage for captcha
const selfRequest = Axios.create({
  baseURL: '/',
  timeout: 5000
})

export default selfRequest
